import { Inject } from '@odinjs/odin';
import { DatePickerAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnChange, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import moment from 'moment/moment.js';
import { FragmentNames, PseudonymAppointmentsStepCheckupCalendarAliases } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import PseudonymAppointmentsBaseController from './pseudonym-appointments-base-controller';
import PseudonymAppointmentModel from './pseudonym-appointments-model';
import { AppointmentsSteps } from './pseudonym-types';
import { ProcedureModel, SchedulingConfig } from './pseudonym-interfaces';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import RescheduleContext from '../../utils/reschedule-utils';
import UserContext from '../../utils/user-context';

@Controller({ component: PseudonymAppointmentsStepCheckupCalendarAliases.LAYOUT_CHECKUP_SCHEDULE_PERIOD, fragment: FragmentNames.PSEUDONYM_APPOINTMENTS_STEP_CHECKUP_CALENDAR })
export default class PseudonymAppointmentsStepCheckupCalendar extends PseudonymAppointmentsBaseController {

  @Inject(PseudonymAppointmentsStepCheckupCalendarAliases.DATE_PICKER_CHECKUP_SCHEDULE_RANGE)
    datePickerScheduleAPI!: DatePickerAPI;

  @OnMount({ target: PseudonymAppointmentsStepCheckupCalendarAliases.PANEL_CHECKUP_SCHEDULE_PERIOD })
  handleMountPanel(): void {
    if (this.historyService.getCurrentRoute().includes(APPLICATION_ROUTES.RESCHEDULE_CHECKUP)) {
      const checkupDetails = { checkupTypeDescription: RescheduleContext.rescheduleCheckup.checkupTypeDescription,
        viewCheckupStepData: RescheduleContext.rescheduleCheckup.stepVisibility, };
      PseudonymAppointmentModel.referenceCompanyCode = RescheduleContext.rescheduleCheckup.companyCode;
      PseudonymAppointmentModel.stepCheckupSuggestions.checkupType = String(RescheduleContext.rescheduleCheckup.checkupType);
      PseudonymAppointmentModel.stepOne.currentPatientSelected.id = UserContext.patientId;
      PseudonymAppointmentModel.stepOne.healthInsurance.categoryId = RescheduleContext.rescheduleCheckup.categoryCode;
      PseudonymAppointmentModel.stepOne.healthInsurance.healthInsuranceId = RescheduleContext.rescheduleCheckup.insuranceCode;
      PseudonymAppointmentModel.stepOne.healthInsurance.planId = RescheduleContext.rescheduleCheckup.planCode;
      PseudonymAppointmentModel.stepTwo.hasCheckup = true;
      PseudonymAppointmentModel.stepTwo.procedures.push(checkupDetails as ProcedureModel);
      this.setWizardStepDone(AppointmentsSteps.STEP_CHECKUP_SCHEDULE, false)
    }
  }

  @OnMount({ target: PseudonymAppointmentsStepCheckupCalendarAliases.DATE_PICKER_CHECKUP_SCHEDULE_RANGE })
  handleMountDatePicker(): void {
    HttpService.get(APPLICATION_ENDPOINTS.GET_CHECKUP_SCHEDULE_CONFIG)
      .then(response => {
        const checkupSchedule = response.body as SchedulingConfig;
        const today = moment().utc().toISOString();
        const endDate = checkupSchedule.schedulingFinalDate.toString();

        this.datePickerScheduleAPI.setIntervalThreshold(checkupSchedule.scheduleRangeAllowed);
        this.datePickerScheduleAPI.addRange(today, endDate);
        this.setInitialRangeToContext(today, endDate);

        PseudonymAppointmentModel.stepSix.selectedDateRange.start = today;
        PseudonymAppointmentModel.stepSix.selectedDateRange.end = endDate;
        PseudonymAppointmentModel.stepSix.allowSelectDesiredDate = checkupSchedule.allowSelectDesiredDate;
        PseudonymAppointmentModel.stepSix.desiredDateCustomMessage = checkupSchedule.desiredDateCustomMessage;
      });
  }

  private setInitialRangeToContext(initialDate: string, finalDate: string): void {
    this.context.set({finalDate: finalDate, initialDate: initialDate});
  }

  @OnChange({ target: PseudonymAppointmentsStepCheckupCalendarAliases.DATE_PICKER_CHECKUP_SCHEDULE_RANGE })
  handleChangeDateRange(event: ChangeEvent<Array<string>>): void {
    const rangeDate = event.value || [];
    const startDate = rangeDate[0];
    const endDate = rangeDate.length === 1 ? rangeDate[0] : rangeDate[1];

    if (rangeDate.length >= 1) {
      PseudonymAppointmentModel.stepSix.selectedDateRange.start = startDate > endDate ? endDate : startDate;
      PseudonymAppointmentModel.stepSix.selectedDateRange.end = startDate > endDate ? startDate : endDate;
      this.setWizardStepDone(AppointmentsSteps.STEP_CHECKUP_SCHEDULE, true);
    } else {
      this.setWizardStepDone(AppointmentsSteps.STEP_CHECKUP_SCHEDULE, false);
    }
  }
}
